var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSocialLinkedin = function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.85 3.315c0-.577.202-1.053.608-1.429.405-.375.932-.562 1.58-.562.638 0 1.153.184 1.547.554.406.38.608.877.608 1.489a1.82 1.82 0 0 1-.59 1.385c-.406.381-.939.572-1.599.572h-.017c-.637 0-1.153-.19-1.547-.572-.393-.38-.59-.86-.59-1.437Zm.225 15.152V6.899h3.858v11.567H1.075Zm5.995 0h3.857v-6.46c0-.403.046-.715.139-.934.162-.393.408-.725.738-.996s.744-.407 1.242-.407c1.298 0 1.947.871 1.947 2.615v6.181h3.857v-6.632c0-1.708-.406-3.004-1.217-3.887-.81-.883-1.882-1.325-3.214-1.325-1.494 0-2.658.641-3.492 1.922v.035h-.018l.018-.035V6.9H7.07c.023.37.034 1.518.034 3.446 0 1.928-.011 4.635-.034 8.121Z",
    fill: "#fff"
  })));
};

export default SvgSocialLinkedin;